<template>
    <section class="gallery-wrap">
        <div class="gallery-container">
            <div class="gallery-outer">
                <div class="gallery-inner">
                    <div class="gallery-item" v-for="(item, index) in galleryList" :key="`gallery-item-${index}`">
                        <a 
                        href="javascript: void(0);" 
                        class="gallery-link" 
                        :class="mouseEnterIndex === index ? 'gallery-link-active' : (mouseEnterIndex !== -1 ? 'gallery-link-inactive' : '')"
                        @click="showGallery(item)"
                        @mouseenter="mouseEnterHandler(index)"
                        @mouseleave="mouseLeaveHandler"
                        >
                            <img :src="item.thumbnailImg" :alt="item.tag" class="gallery-thumbnail">
                        </a>
                    </div>
                </div>
            </div>

            <router-link to="/fankit" target="_blank" class="link-button">
                <i class="iconfont iconchangyongtubiao-xianxingdaochu-zhuanqu-"></i>
                <span>See More</span>
            </router-link>
        </div>
    </section>
</template>

<script>
export default {
    name: "gallery",

    components: {
    },
    data: () => ({
        galleryList: [
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery01.png"),
                galleryImg: require("../../assets/images/gallery/gallery01.jpg"),
                tag: ['#Reunion', '#Talulah']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery02.png"),
                galleryImg: require("../../assets/images/gallery/gallery02.jpg"),
                tag: ['#Kal’tsit', '#Rhodes Island Medical Department']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery03.png"),
                galleryImg: require("../../assets/images/gallery/gallery03.jpg"),
                tag: ['#Ajimu', '#Angelina']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery04.png"),
                galleryImg: require("../../assets/images/gallery/gallery04.jpg"),
                tag: ['#Penguin Logistics', '#Leisure']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery05.png"),
                galleryImg: require("../../assets/images/gallery/gallery05.jpg"),
                tag: ['#target', '#Penguin Logistics']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery06.png"),
                galleryImg: require("../../assets/images/gallery/gallery06.jpg"),
                tag: ['#Kjerag']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery07.png"),
                galleryImg: require("../../assets/images/gallery/gallery07.jpg"),
                tag: ['#RHODES ISLAND', '#Amiya']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery08.png"),
                galleryImg: require("../../assets/images/gallery/gallery08.jpg"),
                tag: ['#Penguin Logistics', '#Exusiai', '#In Combat']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery09.png"),
                galleryImg: require("../../assets/images/gallery/gallery09.jpg"),
                tag: ['#RHODES ISLAND', '#Group Photo']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery10.png"),
                galleryImg: require("../../assets/images/gallery/gallery10.jpg"),
                tag: ['#Kjerag', '#Cliffheart']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery11.png"),
                galleryImg: require("../../assets/images/gallery/gallery11.jpg"),
                tag: ['#Rhodes Island', '#Eyjafjalla']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery12.png"),
                galleryImg: require("../../assets/images/gallery/gallery12.jpg"),
                tag: ['#Kjerag', '#Pramanix']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery13.png"),
                galleryImg: require("../../assets/images/gallery/gallery13.jpg"),
                tag: ['#Reunion', '#Talulah']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery14.png"),
                galleryImg: require("../../assets/images/gallery/gallery14.jpg"),
                tag: ['#Originiums', '#Catastrophe']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery15.png"),
                galleryImg: require("../../assets/images/gallery/gallery15.jpg"),
                tag: ['#Kjerag', '#Gathering']
            },
            {
                thumbnailImg: require("../../assets/images/gallery/thumbnail/gallery16.png"),
                galleryImg: require("../../assets/images/gallery/gallery16.jpg"),
                tag: ['#Lungmen Guard Department']
            },
        ],
        mouseEnterIndex: -1,
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {

    },
    methods: {
        mouseEnterHandler(index) {
            this.mouseEnterIndex = index
        },
        mouseLeaveHandler() {
            this.mouseEnterIndex = -1
        },
        showGallery(item) {
            this.$store.commit("SET_GALLERY_MASK_ACTIVE", {
                show: true,
                img: item.galleryImg,
                tag: item.tag
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.gallery-wrap {
    background-color: #141516;

    .gallery-container {
        position: relative;
        width: 80%;
        max-width: 1400px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .gallery-outer {
            position: relative;
            width: 100%;
            height: 0;
            padding-top: 54%;

            .gallery-inner {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                overflow: hidden;
                display: flex;
                align-content: flex-start;
                flex-direction: column;
                flex-wrap: wrap;

                .gallery-item {
                    width: 20%;
                    position: relative;

                    .gallery-link {
                        display: block;
                        position: relative;
                        overflow: hidden;



                        .gallery-thumbnail {
                            display: block;
                            max-width: 100%;
                            height: auto;
                            transition: all ease-in-out .3s;
                        }

                        &::after {
                            content: "";
                            display: block;
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                            transition: all ease-in-out .3s;
                        }

                        &.gallery-link-active {
                            &::after {
                                background: rgba(255, 255, 255, 0.068);
                            }
                        }
                        &.gallery-link-inactive {
                            &::after {
                                background: rgba(0, 0, 0, 0.26);
                            }
                        }
                        &:hover {
                            .gallery-thumbnail {
                                transform: translateZ(0) scale(1.1);
                            }
                        }
                    }
                }
            }
        }

        .link-button {
            float: right;
            display: block;
            width: pxTorem(193px);
            height: pxTorem(48px);
            margin-top: pxTorem(10px);
            box-sizing: border-box;
            border: 1px solid #22bbff;
            color: #fff;
            font-size: 0;
            line-height: pxTorem(46px);
            text-align: center;
            cursor: pointer;
            transition: all .3s ease-in-out;

            i {
                font-size: pxTorem(20px);
                margin-right: pxTorem(10px);
            }
            span {
                font-family: "STHeiti";
                font-size: pxTorem(18px);
            }

            &:hover {
                background: #22bbff;
                color: #000;
            }
        }
    }

    .test-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(173, 216, 230, 0.418);
        top: 0;
        left: 0;
        z-index: 999;
        
        .test-box {
            width: 500px;
            height: 80%;
            background: lightgray;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
